<template>
  <div class="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4" @click.self="$emit('close')" role="dialog" aria-modal="true" :aria-label="$t('表示言語を選択')">
    <div class="bg-white rounded-q4cl shadow-card-hover w-full max-w-md border border-q4cl-border">
      <header class="px-5 py-3 border-b border-q4cl-border flex items-center justify-between">
        <h3 class="font-bold text-q4cl-primary">{{ $t('表示言語を選択') }}</h3>
        <button class="btn-icon" type="button" @click="$emit('close')" :aria-label="$t('閉じる')"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>
      <ul class="max-h-[60vh] overflow-y-auto divide-y divide-q4cl-border">
        <li v-for="lang in langs" :key="lang.code">
          <button type="button"
            class="w-full text-left px-5 py-3 flex items-center gap-3 hover:bg-q4cl-surface"
            :class="lang.code === current ? 'bg-q4cl-surface font-bold text-q4cl-primary' : ''"
            @click="select(lang.code)"
          >
            <span class="text-sm font-medium text-q4cl-primary min-w-[10rem]">{{ lang.english_name || lang.name || lang.code }}</span>
            <span class="text-sm text-q4cl-ink">{{ lang.local_name || '' }}</span>
            <span class="ml-auto text-xs text-q4cl-muted font-mono" aria-hidden="true">{{ lang.code.toUpperCase() }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalLanguageSelector',
  emits: ['close'],
  setup(_, { emit }) {
    const i18n = window.i18nStore;
    const qs = window.questionnaireStore;

    // 旧旧版踏襲 (ModalLanguageSelector.vue:70-81):
    // qstDef.translate (文字列) を読んで言語リストをフィルター。
    // - 'all'           → 全言語 (ja を除く)
    // - 'major'         → de,en,fr,it,pt,ru,zh,ko (8 言語)
    // - 'en,de,fr,...'  → カンマ区切り CSV で指定された言語のみ
    // ※ 「日本語に戻す」 オプションは UX 上必須なので常にリスト先頭に挿入
    const langs = Vue.computed(() => {
      const all = (i18n.languages || []);
      const ja = all.find((l) => l.code === 'ja');
      const others = all.filter((l) => l.code !== 'ja');
      const t = qs?.state?.qstDef?.translate;
      let filtered = [];
      if (t === 'all') {
        filtered = others;
      } else if (t) {
        const arr = String(t)
          .replace('major', 'de,en,fr,it,pt,ru,zh,ko')
          .replace(/\s/g, '')
          .toLowerCase()
          .replace(/,/g, '|')
          .split('|');
        filtered = others.filter((l) => arr.includes(l.code));
      }
      return ja ? [ja, ...filtered] : filtered;
    });
    const current = Vue.computed(() => i18n.language || 'ja');
    function select(code) {
      i18n.setLanguage(code === 'ja' ? null : code);
      emit('close');
    }
    return { langs, current, select };
  }
};
</script>
